export type Record = {
	[key: string]: string | number | boolean;
};

export enum EOutboundURL {
	ADD_CAMPAIGN_DATA = '/marketing/dashboard/outbound/addCampaignData',
	UPLOAD_CAMPAIGN_DATA_CSV = '/dashboard/uploadCampaignDataCsv/dashboard-outbound-uploadCampaignDataCsv'
}
